var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHouse = function SvgHouse(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 17,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M.219 5.867c0-.187.031-.375.125-.562L2.78.867c.25-.5.75-.812 1.313-.812h12.218c.563 0 1.063.312 1.313.812l2.438 4.438c.093.187.156.375.156.562 0 .656-.563 1.188-1.219 1.188h-.781v8.25a.74.74 0 0 1-.75.75.72.72 0 0 1-.75-.75v-8.25h-4.5v7.75c0 .718-.563 1.25-1.25 1.25H3.438c-.688 0-1.25-.532-1.25-1.25v-7.75h-.782A1.187 1.187 0 0 1 .22 5.867m3.469 1.188v3h7.03v-3zm.406-5.5-2.188 4H18.5l-2.187-4zm6.625 13v-3H3.688v3z"
  })));
};
export default SvgHouse;